import { makeHTTPProvider } from 'shared/infra/providers';

import ErrorHandler from '../helpers/ErrorHandler';

function handleError(error, t, enqueueSnackbar) {
  const errorMsg = ErrorHandler(error);
  enqueueSnackbar(t(errorMsg), {
    variant: 'error',
  });
}

async function fetchPaymentMethodsByDiscountPercentage(
  unitId,
  t,
  enqueueSnackbar,
) {
  try {
    const url = {
      PIX: makeHTTPProvider().get(
        'getBudgetDiscountPercentage?paymentType=PIX',
      ),
      CARTAO_ONLINE: makeHTTPProvider().get(
        'getBudgetDiscountPercentage?paymentType=CARTAO_ONLINE',
      ),
      CARTAO_RECORRENTE: makeHTTPProvider().get(
        `getBudgetDiscountPercentage?unitId=${unitId}&paymentType=CARTAO_RECORRENTE`,
      ),
    };

    const [pix, cart, recurrent] = await Promise.all([
      url.PIX,
      url.CARTAO_ONLINE,
      url.CARTAO_RECORRENTE,
    ]);

    return {
      pixPercentage: pix.percentualDesconto,
      cartPercentage: cart.percentualDesconto,
      recurrentPercentage: recurrent.percentualDesconto,
    };
  } catch (error) {
    handleError(error, t, enqueueSnackbar);
  }
}

const fetchCart = {
  getPaymentMethodsByDiscountPercentage:
    fetchPaymentMethodsByDiscountPercentage,
};

export default fetchCart;
